//AUTH
export const GET_USER_DATA = "GET_USER_DATA";
export const GET_USER_DATA_SUCCESS = "GET_USER_DATA_SUCCESS";
export const GET_USER_DATA_ERROR = "GET_USER_DATA_ERROR";
export const LOGOUT_USER = "LOGOUT_USER";
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS";
export const LOGOUT_USER_ERROR = "LOGOUT_USER_ERROR";
export const ADD_PROCEEDING = "ADD_PROCEEDING";
export const ADD_PROCEEDING_SUCCESS = "ADD_PROCEEDING_SUCCESS";
export const ADD_PROCEEDING_ERROR = "ADD_PROCEEDING_ERROR";

//CENTERS
export const LIST_CENTERS = "LIST_CENTERS";
export const LIST_CENTERS_SUCCESS = "LIST_CENTERS_SUCCESS";
export const LIST_CENTERS_ERROR = "LIST_CENTERS_ERROR";

//JURISDICTIONS
export const LIST_JURISDICTIONS = "LIST_JURISDICTIONS";
export const LIST_JURISDICTIONS_SUCCESS = "LIST_JURISDICTIONS_SUCCESS";
export const LIST_JURISDICTIONS_ERROR = "LIST_JURISDICTIONS_ERROR";
export const SELECT_JURISDICTIONS = "SELECT_JURISDICTIONS";
export const CLOSE_JURISDICTION_LIST = "CLOSE_JURISDICTION_LIST";
export const CLOSE_JURISDICTION_LIST_SUCCESS = "CLOSE_JURISDICTION_LIST_SUCCESS";
export const CLOSE_JURISDICTION_LIST_ERROR = "CLOSE_JURISDICTION_LIST_ERROR";
export const GET_JURISDICTION = "GET_JURISDICTION";
export const GET_JURISDICTION_SUCCESS = "GET_JURISDICTION_SUCCESS";
export const GET_JURISDICTION_ERROR = "GET_JURISDICTION_ERROR";
export const UNSELECT_JURISDICTION = "UNSELECT_JURISDICTION";
export const UNSELECT_JURISDICTION_SUCCESS = "UNSELECT_JURISDICTION_SUCCESS";
export const UNSELECT_JURISDICTION_ERROR = "UNSELECT_JURISDICTION_ERROR";

//PROCEEDING
export const LIST_PROCEEDINGS = "LIST_PROCEEDINGS";
export const LIST_PROCEEDINGS_SUCCESS = "LIST_PROCEEDINGS_SUCCESS";
export const LIST_PROCEEDINGS_ERROR = "LIST_PROCEEDINGS_ERROR";
export const REMOVE_PROCEEDING = "REMOVE_PROCEEDING";
export const REMOVE_PROCEEDING_SUCCESS = "REMOVE_PROCEEDING_SUCCESS";
export const REMOVE_PROCEEDING_ERROR = "REMOVE_PROCEEDING_ERROR";
export const DECODE_URL = "DECODE_URL";
export const DECODE_URL_SUCCESS = "DECODE_URL_SUCCESS";
export const DECODE_URL_ERROR = "DECODE_URL_ERROR";

//HISTORY
export const LIST_PROCEEDING_HISTORY = "LIST_PROCEEDING_HISTORY";
export const LIST_PROCEEDING_HISTORY_SUCCESS = "LIST_PROCEEDING_HISTORY_SUCCESS";
export const LIST_PROCEEDING_HISTORY_ERROR = "LIST_PROCEEDING_HISTORY_ERROR";
export const SELECT_HISTORY = "SELECT_HISTORY";
export const SELECT_HISTORY_SUCCESS = "SELECT_HISTORY_SUCCESS";
export const SELECT_HISTORY_ERROR = "SELECT_HISTORY_ERROR";
export const UNSELECT_HISTORY = "UNSELECT_HISTORY";
export const UNSELECT_HISTORY_SUCCESS = "UNSELECT_HISTORY_SUCCESS";
export const UNSELECT_HISTORY_ERROR = "UNSELECT_HISTORY_ERROR";

//UNITS
export const LIST_UNITS = "LIST_UNITS";
export const LIST_UNITS_SUCCESS = "LIST_UNITS_SUCCESS";
export const LIST_UNITS_ERROR = "LIST_UNITS_ERROR";